import { useEffect, useState } from "react";
import PreLoader from "../../../../core/common/preLoader";
import useFetch from "../../../../hooks/useFetch";
import { API } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";

import CommonSelectV2 from "../../../../core/common/commonSelectV2";
import { Link } from "react-router";

interface Props {
    classOpts: any[]
    selectedStudents: any[]
    onSuccess: () => void;
    readonly?: boolean
}
const PropomoteStudent = ({ classOpts, selectedStudents, onSuccess, readonly }: Props) => {
    const { isLoading, error, data, status, callFetch } = useFetch();
    const [selectedBatch, setSelectedBatch] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const [showMsgBox, setShowMsgBox] = useState<boolean>(false)

    const reset = () => {
        resetMsgBox()
    }

    const resetMsgBox = () => {
        setErrorMessage("")
    }

    useEffect(() => {
        if (data && status && status < 299) {
            setErrorMessage("")
            setShowMsgBox(true)
            onSuccess()
        }
    }, [status]);

    useEffect(() => {
        if (error) {
            if (error.response?.data) {
                setErrorMessage(error.response?.data)
            } else {
                setErrorMessage('Something went wrong please try again later.')
            }
        }
    }, [error]);

    const handleSubmit = () => {
        if(!selectedBatch){
            setErrorMessage("Please select a class.")
        } else {
            setErrorMessage("")
            callFetch(API.PROMOTE_STUDENTS, 
                'PUT', 
                getAPIHeaders(), 
                null, 
                {
                    studentIds: selectedStudents,
                    batchId: selectedBatch,
                }
            )
        }
    };


    const renderForm = () => {

        return (
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title">Propmote Students</h4>
                    <button
                        type="button"
                        className="btn-close custom-btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={reset}
                    >
                        <i className="ti ti-x" />
                    </button>
                </div>
                <form>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Class <span className="text-danger"> *</span></label>
                                    <CommonSelectV2
                                        disabled={readonly}
                                        className='select'
                                        options={classOpts}

                                        onChange={(value: any) => {
                                            setSelectedBatch(value)
                                        }}

                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="modal-footer" style={{ 
                justifyContent: "space-between",
                flexDirection:'row'}}>
                <div style={{maxWidth:"50%"}}>
                        { errorMessage  ?
                          <>
                            <i className="ti ti-alert-triangle text-danger" />  
                            <span className='text-danger'> {errorMessage} </span> 
                          </> 
                          : <></>
                        }
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={reset}
                  >
                    Cancel
                  </button>
                  <button type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}>
                    Promote
                  </button>
              </div>
            </div>
                </form>
            </div>
        )
    }


    const renderMsgBox = () => {
        return (          
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
                <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                    <i className="ti ti-thumb-up fs-36" />
                </span>
                <h4 className="mb-1">Promoted Students Successfull</h4>
                <p className="mb-3">
                    Students are promoted to new class {classOpts.find((item:any)=>item.value === selectedBatch)?.label} successfully.
                </p>
                <div className="d-flex justify-content-center">
                    <Link to="#" 
                        data-bs-dismiss="modal" 
                        className="btn btn-success"
                        onClick={()=>{
                          setTimeout(() => {
                            setShowMsgBox(false);
                          }, 1000);
                          }}>
                        Close
                    </Link>
                </div>
            </div>
        </div>
      </div>)
      }

    return (
        <div className="modal fade" id="promote_student"
            data-bs-backdrop="static"
            data-bs-keyboard="false">
            <PreLoader showLoader={isLoading} />
            <div className="modal-dialog modal-dialog-centered modal-md"
            >
                {showMsgBox ? renderMsgBox() : renderForm()}
            </div>
        </div>
    )
}

export default PropomoteStudent;